// src/Footer.js
import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      <footer
        className="site-footer bg-img-fix footer-action"
        style={{
          backgroundImage: "url(assets/images/background/footer-bg.png)",
        }}
        id="footer"
      >
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-5 order-2 order-lg-0">
                <div className="widget widget_about text-start">
                  {/* <h5
                    className="footer-title wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    Subscribe Here
                  </h5>
                  <form
                    className="dzSubscribe dz-subscribe-wrapper1 wow fadeInUp"
                    data-wow-delay="0.4s"
                    action="assets/script/mailchamp.php"
                    method="post"
                  >
                    <div className="dzSubscribeMsg"></div>
                    <div className="form-group">
                      <div className="input-group mb-0">
                        <input
                          name="dzEmail"
                          required="required"
                          type="email"
                          className="form-control"
                          placeholder="Email Address"
                        />
                        <div className="input-group-addon">
                          <button
                            name="submit"
                            value="Submit"
                            type="submit"
                            className="mail-sent"
                          >
                            <i className="flaticon-sent"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form> */}
                </div>
              </div>
              <div className="col-xl-4 col-lg-2">
                <div className="footer-logo logo-center">
                  <a
                    href="index.html"
                    style={{
                      color: "#fff",
                      fontWeight: "900",
                      fontFamily: "sans-serif",
                      fontSize: "20px",
                    }}
                  >
                    Liberty Web Guard
                  </a>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5 text-end">
                <div className="widget widget_locations">
                  {/* <h5
                    className="footer-title wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    Stay Connected
                  </h5>
                  <div
                    className="dz-social-icon dz-hover-move icon-gap-5 wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <ul>
                      <li>
                        <a
                          target="_blank"
                          className="btn-social btn-transparent btn-circle"
                          href="https://www.facebook.com/"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          className="btn-social btn-transparent btn-circle"
                          href="https://www.instagram.com/"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          className="btn-social btn-transparent btn-circle"
                          href="https://twitter.com/"
                        >
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          className="btn-social btn-transparent btn-circle"
                          href="https://whatsapp.com/"
                        >
                          <i className="fa-brands fa-whatsapp"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          className="btn-social btn-transparent btn-circle"
                          href="https://www.linkedin.com/"
                        >
                          <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
              <div
                className="col-xl-12 wow fadeInUp"
                style={{ marginTop: "5%" }}
                data-wow-delay="0.6s"
              >
                <div className="footer-menu">
                  <ul className="">
                    <li>
                      <a href="/Dashboard">HOME</a>
                    </li>
                    <li>
                      <a href="/AllPlans">JOBS</a>
                    </li>
                    <li>
                      <a href="/CreateTask">TASK</a>
                    </li>
                    <li>
                      <a href="/Profile">PROFILE</a>
                    </li>
                    <li>
                      <a href="/MyEarnings">EARNINGS</a>
                    </li>
                    <li>
                      <a href="/Transactions">TRANSACTIONS</a>
                    </li>
                    <li>
                      <a href="/ChangePassword">CHANGE PASSWORD</a>
                    </li>
                    <li>
                      <a href="/">LOGOUT</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="footer-bottom">
            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <p
                  className="copyright-text"
                  style={{ textAlign: "center", fontSize: "20px" }}
                >
                  Copyright © 2026
                  <a href="#" target="_blank">
                    , Liberty Web Guard
                  </a>
                  . All rights reserved.
                </p>
              </div>
              <div className="col-xl-6 col-lg-6">
                {/* <ul className="footer-link">
                  <li>
                    <a href="#">Privacy Notice</a>
                  </li>
                  <li>
                    <a href="#">About</a>
                  </li>
                  <li>
                    <a href="#">Terms & Conditions</a>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div class="scroltop-progress scroltop-primary">
        <svg width="100%" height="100%" viewbox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
        </svg>
      </div>
    </React.Fragment>
  );
};

export default Footer;
